import { PageInfo, TableFetchData } from "@powerledger/ui-component-lib";
import { FormikProps } from "formik";

import { AllRecOptions } from "@/app/hooks/use-all-rec-options";
import { ReturnTypeFormatAttributes } from "@/app/lib/format-attributes";
import {
  ERCOTUnSupportedColumns,
  MRETSUnSupportedColumns,
  UnSupportedColumns,
} from "@/app/lib/registry-attributes-helpers";
import { RecHoldingsTableData } from "@/app/pages/recs/rec-holdings/rec-holdings.types";
import {
  AssetSpecificationInput,
  AssetType,
  ErcotRecAttributes,
  MretsRecAttributes,
  RecAttributes,
  RegistryCode,
  TradeContract,
  TradeContractAsset,
  TradeContractStatus,
} from "@/app/types/generated/graphql";
import { AggregatedRegistryCode } from "@/app/types/okta.types";

export type RecAssetAttributes = ErcotRecAttributes | MretsRecAttributes;

export type TradeContractAssetsTableData = Omit<TradeContractAsset, "attributes"> & {
  attributes: RecAttributes;
  registryDisplayName: string;
} & ReturnTypeFormatAttributes;

export type ForwardTradeRecsAssignCustomProps = {
  tradeContractNumber: string;
  tradeContractRegistryCode: AggregatedRegistryCode;
  tradeContractId: string;
  askTradeVolume: number;
  tradeAttributes: RecAttributes;
  status: TradeContractStatus;
  assetAssignmentStatus: TradeContract["assetAssignmentStatus"];
};

export type ForwardTradeRecsAssignModalProps = ForwardTradeRecsAssignCustomProps & {
  visible: boolean;
  closeModal: () => void;
};

export type ForwardTradeRecsAssignViewProps = Pick<
  ForwardTradeRecsAssignModalProps,
  "visible" | "closeModal" | "tradeContractNumber"
> & {
  contractAssetsTableData: TradeContractAssetsTableData[];
  recsHoldingTableData: RecHoldingsTableData[];
  recOptionsByRegistryCode?: AllRecOptions["recOptionsByRegistryCode"];
  contractAssetsLoading: boolean;
  recsHoldingLoading: boolean;
  reloadTradeContractAssest: () => void;
  formikProps: Partial<FormikProps<AssignAssetsFormValues>>;
  onAssignRecs: (values: AssignAssetsFormValues) => Promise<void>;
  pageInfo: PageInfo;
  fetchData: TableFetchData<RecHoldingsTableData>;
  reloadRecsHolding: () => void;
  currentRequiredVolume: number;
  showAssignRECsTable: boolean;
  showViewRECsTable: boolean;
  totalAssignedRecs: number;
  hiddenColumns: string[];
  enableCrossRegistryForwardTrading: boolean;
  followErcotNamingConvention: boolean;
};

export type AssignAssetsFormValues = {
  assetType: AssetType;
  tradeContractId: string;
  assetsToAssign: Array<AssetSpecificationInput & { availableVolume?: number }>;
};

export type CustomVolumeError = {
  customVolumeError: string;
};

export const RecAssignmentUnSupportedColumns: UnSupportedColumns = {
  [RegistryCode.Mrets]: {
    unsupportedColumns: MRETSUnSupportedColumns,
    toggleColumns: [],
  },
  [RegistryCode.Ercot]: {
    unsupportedColumns: ERCOTUnSupportedColumns,
    toggleColumns: [],
  },
};
